// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledLoading = styled('div')(
  () => css`
    width: 100%;
    .custom-loading {
      text-align: center;
      width: 100%;
      .loading-text {
        margin-top: 30px;
        text-align: center;
      }
    }
  `
);
